import { post } from '@kit/utils/APIV1.js'

//https://localhost/cms-service/index.php/wp-json/v1/home
export const signup = async(jsonFormData) => {
  return post("signup", jsonFormData)
}
